export default {
    computed: {
       subcategories() {return this.$store.getters.getCurrentSubCategories }
    }
}